<div class="detail-dialog">

    <mat-tab-group [(selectedIndex)]="elementTabIndex" class="tabs" dynamicHeight>

        @for (elementId of elements; track elementId) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="label">
                        <img alt="{{'ELEMENT.' + elementId.toUpperCase() | translate}}"
                              src="assets/images/element/{{elementId}}.webp">
                        {{ 'ELEMENT.' + elementId.toUpperCase() | translate }}
                    </div>
                </ng-template>
                <article class="description">
                    <h2>
                        {{ 'ELEMENT.' + elementId.toUpperCase() | translate }}
                    </h2>
                    <p [innerHTML]="'ELEMENT_INFO.' + elementId.toUpperCase()  | translate"></p>
                </article>
            </mat-tab>
        }

    </mat-tab-group>


</div>
